import { useMemo } from 'react';
import type { IRecordTypeDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IVizLabels } from './IVizLabels';

/** Підписи варіантів полів і статусів дочірньої таблиці діаграми (рядки модуля → підписи визначення → значення). */
export function useVizLabels(rt: IRecordTypeDefinition | undefined): IVizLabels {
  const strings = useModuleStrings();
  return useMemo(() => ({
    option: (field: string, value: unknown) => {
      const v = value == null ? '' : String(value);
      if (!v || !rt) return v;
      return strings.option(rt.key, field, v, rt.fields.find((f) => f.key === field)?.options?.find((o) => o.value === v)?.label);
    },
    status: (value: string) => (rt ? strings.status(rt.key, value, rt.statuses.list.find((s) => s.value === value)?.label) : value),
  }), [rt, strings]);
}
